import React from 'react'
import { Helmet } from 'react-helmet'
import HomeLayout from '../pageLayouts/HomeLayout'

const home = () => {
  return (
    <HomeLayout>
      <Helmet>
        <title>minera（ミネラ）</title>
      </Helmet>
    </HomeLayout>
  )
}

export default home
